/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const HomeIcon: FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <path d="M16 4C16.2803 4 16.5478 4.11765 16.7372 4.32428L27.7372 16.3243C28.0051 16.6166 28.0751 17.0397 27.9154 17.4027C27.7557 17.7657 27.3966 18 27 18H25V27C25 27.5523 24.5523 28 24 28H18C17.4477 28 17 27.5523 17 27V20H15V27C15 27.5523 14.5523 28 14 28H8.00002C7.44774 28 7.00002 27.5523 7.00002 27V18H5.00002C4.60345 18 4.24436 17.7657 4.08467 17.4027C3.92499 17.0397 3.9949 16.6166 4.26287 16.3243L15.2629 4.32428C15.4523 4.11765 15.7197 4 16 4ZM7.27326 16H8.00002C8.5523 16 9.00002 16.4477 9.00002 17V26H13V19C13 18.4477 13.4477 18 14 18H18C18.5523 18 19 18.4477 19 19V26H23V17C23 16.4477 23.4477 16 24 16H24.7268L16 6.47989L7.27326 16Z" />
  </BaseIcon>
);
